// Base styles
import typography from "assets/theme/base/typography";

const { size } = typography;

// types
type Types = any;

const inputLabel: Types = {
  styleOverrides: {
    root: {
      fontSize: size.xs,
      lineHeight: 1,

      "&.MuiInputLabel-shrink": {
        lineHeight: 1.5,
        fontSize: size.xs,

        "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
          fontSize: "0.85em",
        },
      },
    },

    sizeSmall: {
      fontSize: size.xs,
      lineHeight: 1.625,

      "&.MuiInputLabel-shrink": {
        lineHeight: 1.6,
        fontSize: size.sm,

        "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
          fontSize: "0.82em",
        },
      },
    },
  },
};

export default inputLabel;
